import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { cn } from '../utils/classUtils';

type IconTextProps = {
  onClick?: () => void;
  label: string | undefined;
  icon: IconDefinition;
  containerStyle?: string;
  iconStyle?: string;
  labelStyle?: string;
};
const IconText: React.FC<IconTextProps> = ({
  onClick,
  label,
  icon,
  containerStyle,
  iconStyle,
  labelStyle,
}) => {
  return (
    <p
      className={cn(
        'flex flex-row items-center lg:justify-start gap-2 w-full',
        containerStyle,
        onClick ? 'cursor-pointer' : '',
      )}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={icon}
        fontSize={14}
        className={cn('text-white', iconStyle)}
      />
      {label && (
        <span
          className={cn(
            'font-inter font-light text-reskin-regent-400 text-sm',
            labelStyle,
          )}
        >
          {label}
        </span>
      )}
    </p>
  );
};

export default IconText;
